import { useMemo } from 'react';

import { useReferralProgramStatisticsQuery } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useChainId } from '@occc-app/Chain/hooks';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useQuery } from '@occc-app/dataAccessLayer/utils';

export const useReferralProgramStatistics = () => {
  const chainId = useChainId();
  const { data, loading } = useQuery(useReferralProgramStatisticsQuery, { variables: { chainId } });

  const statistics = useMemo(() => {
    if (!data) return null;
    return data.referralProgramStatistics;
  }, [data]);

  return { statistics, loading };
};
